import MatchBox from "../../matches/MatchBox";
import {getLoggedUser} from "../../../util/SecurityUtils";
import {useTranslation} from "react-i18next";
import {TOURNAMENT_STATES} from "../../../util/Constants";
import type {TournamentDetail, TournamentRound, Match, PlayerScore} from "../../../types/domain";

interface MyMatchesTabProps {
  tournament: TournamentDetail;
}

function MyMatchesTab(props: MyMatchesTabProps) {
  const { t } = useTranslation();

    const playerId = getLoggedUser()?.playerId
    if (!playerId) {
      return <div>Please log in to see your matches.</div>
    }
    const tournament = props.tournament;
    const playerSeeding = tournament?.players?.find(p => p.player.id === playerId)?.seeding ?? "?";

    const renderRound = (round: TournamentRound, isLastRound: boolean) => {
      const roundMatches = round.matches
        .filter((m: Match) => m.playerOne.id === playerId || m.playerTwo.id === playerId)
        .sort((a: Match, b: Match) =>
          (new Date(a.finishedAt ?? 0).getTime() - new Date(b.finishedAt ?? 0).getTime())
          || (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        );
      const placement = round.scores.findIndex((score: PlayerScore) => score.player.id === playerId) + 1
      return (
        <>
          <div className="vertical-line"></div>
          {roundMatches.map((match) => (
            <div className="justify-content-center" key={"my-match-wrap-" + match.id}>
              <div style={{maxWidth: "720px", margin: "auto"}}>
                <MatchBox match={match} />
              </div>
            </div>
          ))}
          { round.state === TOURNAMENT_STATES.FINISHED && <div className="vertical-line"></div> }
          { round.state === TOURNAMENT_STATES.FINISHED && tournament.type === "SWISS" &&
            <div className="text-center">
              {isLastRound ? <span className="fw-bold fs-4">{t("myMatches__end" + (placement <= 3 ? "_wellDone" : ""), {placement: placement})}</span>
                : <span>{t("myMatches__swissRound", {round: round.roundOrder, placement: placement})}</span> }
            </div>
          }
          {round.state === TOURNAMENT_STATES.FINISHED && tournament.type === "GROUPS" &&
            <div className="text-center">
              {isLastRound ? <span className="fw-bold fs-4">{t("myMatches__end" + (placement <= 3 ? "_wellDone" : ""), {placement: placement})}</span>
                : <span className="fw-bold fs-4">{t("myMatches__groupRound", {placement: placement})}</span> }
            </div>
          }
          {round.state === TOURNAMENT_STATES.FINISHED && tournament.type === "GROUPS_PLAYOFF" &&
            <div className="text-center">
              {isLastRound ? <span className="fw-bold fs-4">{t("myMatches__end" + (placement <= 3 ? "_wellDone" : ""), {placement: placement})}</span>
                : round.roundOrder === 1 ? <span className="fw-bold fs-4">{t("myMatches__groupRound", {placement: placement})}</span>
                : <span>{t("myMatches__playoffRound", {round: round.roundOrder - 1})}</span> }
            </div>
          }
        </>
      )
    }

    return (
        <>
            <div className="match-records-grid d-flex flex-column-reverse" >
              <div className="text-center">
                <span className="fw-bold fs-4">{t("myMatches__start", {seeding: playerSeeding})}</span>
              </div>
              {tournament.rounds.map((round, index) => (
                <div key={"my-round-" + round.id}>
                  {renderRound(round, index === tournament.rounds.length - 1 && tournament.state === TOURNAMENT_STATES.FINISHED)}
                </div>
              ))}
            </div>
        </>
    );
}

export default MyMatchesTab
